export default "__VITE_ASSET__0287d7aa__"